export default __webpack_public_path__ + "images/JA.ea19542.png";